import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName } from '../utils';

/** 取込区分 */
enum ImportType {
  replace = 'REPLACE',
  insert = 'INSERT',
  update = 'UPDATE',
}

const nameConfig = {
  replace: new Map([
    [Locale.ja, '全件洗い替え :既存のデータをすべて削除した後、取込データを挿入します。'],
    [Locale.en, 'Reset All : Insert imported data after deleting all existing data.'],
  ]),
  insert: new Map([
    [
      Locale.ja,
      'データの追加 :取込データを既存のデータに追加します。\n重複するデータが存在する場合、エラーとなりすべての取込処理が無効になります。',
    ],
    [
      Locale.en,
      'Add Data: Append the incoming data to the existing data. \nIf duplicate data exists, an error will occur and all import processing will be disabled.',
    ],
  ]),
  update: new Map([
    [
      Locale.ja,
      'データの追加・更新 :取込データを既存のデータに追加します。\n重複するデータが存在する場合、取込データの内容に上書きされます。',
    ],
    [
      Locale.en,
      'Add/Update Data: Add imported data to existing data. \nIf duplicate data exists, it will be overwritten with the contents of the imported data.',
    ],
  ]),
};

const toDisplay = enumToName(ImportType, nameConfig);
const toDisplayWithPrefix = enumToName(ImportType, nameConfig, { prefix: true });

export const importType = {
  enum: ImportType,
  nameConfig,
  toDisplay,
  toDisplayWithPrefix,
};
export type { ImportType };
